"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECT_DELAY_IN_SECONDS = exports.SECOND = void 0;
var SECOND = 1000;
exports.SECOND = SECOND;
var REDIRECT_DELAY_IN_SECONDS = 3;
exports.REDIRECT_DELAY_IN_SECONDS = REDIRECT_DELAY_IN_SECONDS;